import { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { useEffectSkipFirst, useForm, useQuery } from 'utils/hooks'
import { Button, Table } from 'react-bootstrap'
import { GlobalStateContext } from 'contexts/global_state_context'
import { Flex } from 'components/shared/flex'
import lodash from 'lodash'
import { A4 } from 'components/shared/print'
import { BiCheckboxChecked } from 'react-icons/bi'
import { MaterialTaskData, TaskSearchForm } from 'entities/task'
import { useFetchTasksApi } from 'api/task'
import { MaterialTaskSetData } from 'entities/task_set'
import _ from 'lodash'
import { setPageSize } from 'utils/util'
import { useFetchMaterialsApi } from 'api/material'
import { MaterialSearchForm } from 'entities/material'

type InstitutionData = { institutionName?: string; materials?: { materialName?: string; number?: number }[] }
type Props = {
    history: H.History
}

const PrintMaterialTasksPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const query = useQuery<TaskSearchForm>()
    const searchForm = useForm<TaskSearchForm>({ ...query, perPage: 10000 })
    const api = useFetchTasksApi(searchForm)
    const section = 24
    const [materials, setMaterials] = useState<string[]>([])
    const [institutionList, setInstitutionList] = useState<InstitutionData[]>([])
    const materialsSearchForm = useForm<MaterialSearchForm>({ perPage: 100000 })
    const materialsApi = useFetchMaterialsApi(materialsSearchForm)

    useEffect(() => {
        api.execute()
        materialsApi.execute()
        setPageSize('landscape')
    }, [])

    useEffectSkipFirst(() => {
        globalState.setLoading(api.loading)
        if (api.isSuccess()) {
            setData()
        }
    }, [api.loading])

    const setData = () => {
        const materialItems: string[] = []
        const institutionDataList: InstitutionData[] = []
        api.response.results.forEach((task) => {
            const taskSetData: MaterialTaskSetData = JSON.parse(task.taskSet!.data!)
            const taskData: MaterialTaskData = JSON.parse(task.data!)
            const institutionData = institutionDataList.find((d) => d.institutionName === taskSetData.institution_name) || {}
            if (!institutionData.institutionName) {
                institutionData.institutionName = taskSetData.institution_name
                institutionDataList.push(institutionData)
            }
            let material = institutionData.materials?.find((m) => m.materialName === taskData.material_name)
            if (material) {
                material.number! += taskData.number!
            } else {
                material = { materialName: taskData.material_name, number: taskData.number }
                if (!institutionData.materials) {
                    institutionData.materials = []
                }
                institutionData.materials.push(material!)
            }
            materialItems.push(taskData.material_name!)
        })

        setMaterials(_.uniq(materialItems))
        setInstitutionList(institutionDataList)
    }

    const chunks = (): InstitutionData[][] => {
        return lodash.chunk(institutionList, section)
    }

    return (
        <>
            <Flex className="no-print" style={{ marginLeft: 20 }} alignItems="flex-end">
                <div style={{ padding: 15 }}>
                    <Button
                        style={{ width: 200 }}
                        onClick={() => {
                            window.print()
                        }}
                    >
                        印刷プレビュー
                    </Button>
                </div>
            </Flex>
            <A4 padding={5} landscape>
                <div style={{ fontSize: 20, marginBottom: 20 }}>用意するもの</div>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ width: 30, padding: 0, textAlign: 'center' }}></th>
                            <th>資材</th>
                            <th style={{ width: 60 }}>部数</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(() => {
                            const result: { name: string; num: number; id: number }[] = []
                            api.response.results.forEach((task) => {
                                const data: MaterialTaskData = JSON.parse(task.data || '{}')
                                const d = result.find((r) => r.id === data.material_id)
                                if (d) {
                                    d.num += Number(data.number!)
                                } else {
                                    result.push({ name: data.material_name!, id: data.material_id!, num: Number(data.number!) })
                                }
                            })
                            return result.map((data, index) => {
                                const material = materialsApi.response.results.find((m) => m.id == data.id)
                                return (
                                    <tr key={'aggregation-' + index}>
                                        <td style={{ verticalAlign: 'middle' }}>
                                            <div style={{ border: 'solid 1px #888', height: 10, width: 10 }}></div>
                                        </td>
                                        <td>
                                            {data.name} {material && `[Ver.${material?.currentVersion?.number}]`}
                                        </td>
                                        <td>{data.num}部</td>
                                    </tr>
                                )
                            })
                        })()}
                    </tbody>
                </Table>
                <div></div>
            </A4>
            {api.response.results &&
                chunks().map((chunk, i) => {
                    return (
                        <A4 padding={5} landscape key={'page' + i}>
                            <Table bordered style={{ fontSize: 9, marginTop: 10, backgroundColor: '' }}>
                                <thead>
                                    <tr style={{ verticalAlign: 'middle' }}>
                                        <th style={{ width: 30, padding: 0, textAlign: 'center' }}>
                                            <BiCheckboxChecked size={20}></BiCheckboxChecked>
                                        </th>
                                        <th style={{ minWidth: 200 }}>施設名</th>
                                        {materials.map((material, idx) => {
                                            return (
                                                <th key={'material-th-' + idx} style={{ textAlign: 'center' }}>
                                                    {material}
                                                </th>
                                            )
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    {chunk.map((institutionData, j) => {
                                        return (
                                            <tr key={'institution-data-' + j}>
                                                <td style={{ verticalAlign: 'middle' }}>
                                                    <div style={{ border: 'solid 1px #888', height: 10, width: 10 }}></div>
                                                </td>
                                                <td>{institutionData.institutionName}</td>
                                                {materials.map((material, idx) => {
                                                    return (
                                                        <td key={'institution-' + j + '-material-' + idx} style={{ textAlign: 'center' }}>
                                                            {(() => {
                                                                const m = institutionData.materials?.find((m) => m.materialName === material)
                                                                if (m) {
                                                                    return (
                                                                        <Flex alignItems="center" justifyContent="center">
                                                                            {m.number}
                                                                            <div style={{ transform: 'scale(70%)' }}>部</div>
                                                                        </Flex>
                                                                    )
                                                                } else {
                                                                    return '-'
                                                                }
                                                            })()}
                                                        </td>
                                                    )
                                                })}
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </A4>
                    )
                })}
        </>
    )
}

export default withRouter(PrintMaterialTasksPage)
